import * as Dtos from '@/api/dtos';
import ErrorView from '@/components/form/inputs/ErrorView';
import RegistrationField from '@/components/RegistrationField';
import IsNextYearEarlyRegistrationContext from '@/contexts/IsNextYearEarlyRegistrationContext';
import { StepContext } from '@/contexts/StepContext';
import { Box, Grid, Paper, Typography } from '@mui/material';
import { Select } from '@ngt/forms';
import { Condition, ConditionMode, useScopedField } from '@ngt/forms-core';
import { FC, useContext } from 'react';
import GetPrice from '../../GetPrice';

const hasCostCondition = ({value}: any) => value?.cost > 0;

const paymentTypeOptions = [
    { id: Dtos.AdminPaymentType.ETransferFunds, value: 'Electronic Funds Transfer' },
    { id: Dtos.AdminPaymentType.Card, value: 'Credit Card' }
];

const PaymentErrorDisplay = () => {
    const {state: { errors }} = useScopedField('payments', { errors: true })
    
    if (!errors || errors.length === 0) {
        return null;
    }

    return (
        <div style={{paddingTop: 10}}>
            <RegistrationField
                    propertyPath="payments"
                    component={ErrorView}
                    view="Alerts"
                    errors={errors}

                />
        </div>
    );
}

const RegistrationStepFive: FC = () => {
    const isNextYearEarlyRegistration = useContext(IsNextYearEarlyRegistrationContext);
    return (
        <StepContext.Provider value={4}>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    mb:0
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <Condition
                        condition={hasCostCondition}
                        subscription={{value: true}}
                        mode={ConditionMode.Show}
                    >
                        <Typography
                            variant="h3"
                            color='secondary'
                            sx={{
                                mt: 3
                            }}
                        >
                            Payment Options
                        </Typography>
                        <PaymentErrorDisplay />
                        <Paper
                            sx={{
                                p: 4,
                                pt: 0,
                                mt: { xs: 1, md: 3 }
                            }}
                        >
                            <Grid  
                                container
                                columnSpacing={4}
                            >
                                <Grid
                                    item
                                    xs={12}
                                    md={6}
                                    mt={4}
                                >
                                   {/* Only credit card is available for next-year early registrations. */}
                                    <RegistrationField
                                        label="Payment Type"
                                        propertyPath="payments[0].paymentType"
                                        component={Select}
                                        FormControlProps={{
                                            variant: "standard"
                                        }}
                                        options={isNextYearEarlyRegistration ? paymentTypeOptions : []}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    md={6}
                                    mt={4}
                                >
                                    <Box
                                        sx={{
                                            color: "#EC008C",
                                            border: 1,
                                            borderRadius: 4,
                                            borderColor: "#EC008C",
                                            py: 1,
                                            px: 2,
                                            textAlign: 'center'
                                        }}
                                    >
                                        <b>Total Left to pay: <GetPrice/></b>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Condition>
                </Box>
            </Box>
        </StepContext.Provider>
    )}

export default RegistrationStepFive;